"use strict";
var EVENTS = {
    add_director: {
        name: 'ADD DIRECTOR',
        ref: 'add_director'
    },
    delete_director: {
        name: 'DELETE DIRECTOR',
        ref: 'delete_director'
    },
    update_director: {
        name: 'UPDATE DIRECTOR',
        ref: 'update_director'
    },
    add_shareholder: {
        name: 'ADD SHAREHOLDER',
        ref: 'add_shareholder'
    },
    delete_shareholder: {
        name: 'DELETE SHAREHOLDER',
        ref: 'delete_shareholder'
    },
    update_shareholder: {
        name: 'UPDATE SHAREHOLDER',
        ref: 'update_shareholder'
    },
    create_task: {
        name: 'CREATE TASK',
        ref: 'create_task'
    },
    complete_task: {
        name: 'COMPLETE TASK',
        ref: 'complete_task'
    },
    restore_task: {
        name: 'RESTORE TASK',
        ref: 'restore_task'
    },
    create_task_message: {
        name: 'CREATE TASK MESSAGE',
        ref: 'create_task_message'
    },
    user_login: {
        name: 'USER LOGIN',
        ref: 'user_login'
    },
    user_logout: {
        name: 'USER LOGOUT',
        ref: 'user_logout'
    },
    update_user_info: {
        name: 'UPDATE USER INFO',
        ref: 'update_user_info'
    },
    incorporation_form_usage: {
        name: 'INCORPORATION FORM USAGE',
        ref: 'incorporation_form_usage'
    },
    update_user_role_info: {
        name: 'UPDATE USER ROLE INFO',
        ref: 'update_user_role_info'
    },
    delete_user_role_info: {
        name: 'DELETE USER ROLE INFO',
        ref: 'delete_user_role_info'
    },
    update_user_role_info_from_group: {
        name: 'UPDATE USER ROLE INFO FROM GROUP',
        ref: 'update_user_role_info_from_group'
    },
    delete_user_role_info_from_group: {
        name: 'DELETE USER ROLE INFO FROM GROUP',
        ref: 'delete_user_role_info_from_group'
    },
    bizfile_extractor_usage: {
        name: 'BIZFILE EXTRACTOR USAGE',
        ref: 'bizfile_extractor_usage'
    },
    generate_document: {
        name: 'GENERATE DOCUMENT',
        ref: 'generate_document'
    },
    update_generated_document: {
        name: 'UPDATE GENERATED DOCUMENT',
        ref: 'update_generated_document'
    },
    view_dashboard: {
        name: 'VIEW DASHBOARD',
        ref: 'view_dashboard'
    },
    view_financials: {
        name: 'VIEW FINANCIALS',
        ref: 'view_financials'
    },
    view_tasks: {
        name: 'VIEW TASKS',
        ref: 'view_tasks'
    },
    view_timeline: {
        name: 'VIEW TIMELINE',
        ref: 'view_timeline'
    },
    view_expenses: {
        name: 'VIEW EXPENSES',
        ref: 'view_expenses'
    },
    view_bills: {
        name: 'VIEW BILLS',
        ref: 'view_bills'
    },
    view_marketplace: {
        name: 'VIEW MARKETPLACE',
        ref: 'view_marketplace'
    },
    view_subscription: {
        name: 'VIEW SUBSCRIPTION',
        ref: 'view_subscription'
    },
    view_boardroom: {
        name: 'VIEW BOARDROOM',
        ref: 'view_boardroom'
    },
    view_entity_overview: {
        name: 'VIEW ENTITY OVERVIEW',
        ref: 'view_entity_overview'
    },
    view_cap_table: {
        name: 'VIEW CAP TABLE',
        ref: 'view_cap_table'
    },
    view_user_settings: {
        name: 'VIEW USER SETTINGS',
        ref: 'view_user_settings'
    },
    view_admin_settings: {
        name: 'VIEW ADMIN SETTINGS',
        ref: 'view_admin_settings'
    },
    view_verifications: {
        name: 'VIEW VERIFICATIONS',
        ref: 'view_verifications'
    },
    view_task_message_history: {
        name: 'VIEW TASK MESSAGE HISTORY',
        ref: 'view_task_message_history'
    },
    view_entity_details: {
        name: 'VIEW ENTITY DETAILS',
        ref: 'view_entity_details'
    },
    view_entities_list: {
        name: 'VIEW ENTITIES LIST',
        ref: 'view_entities_list'
    },
    view_captured_submissions: {
        name: 'VIEW CAPTURED SUBMISSIONS',
        ref: 'view_captured_submissions'
    },
    view_user_management: {
        name: 'VIEW USER MANAGEMENT',
        ref: 'view_user_management'
    },
    view_user_group_management: {
        name: 'VIEW USER GROUP MANAGEMENT',
        ref: 'view_user_group_management'
    },
    view_members_list: {
        name: 'VIEW MEMBERS LIST',
        ref: 'view_members_list'
    },
    view_member_details: {
        name: 'VIEW MEMBER DETAILS',
        ref: 'view_member_details'
    },
    view_member_document_details: {
        name: 'VIEW MEMBER DOCUMENT DETAILS',
        ref: 'view_member_document_details'
    },
    navigation_client_portal: {
        name: 'NAVIGATION CLIENT PORTAL',
        ref: 'navigation_client_portal'
    },
    navigation_service_provider_portal: {
        name: 'NAVIGATION SERVICE PROVIDER PORTAL',
        ref: 'navigation_service_provider_portal'
    },
    task_concierge_session_info: {
        name: 'TASK CONCIERGE SESSION INFO',
        ref: 'task_concierge_session_info'
    },
    task_concierge_nlu_data: {
        name: 'TASK CONCIERGE NLU DATA',
        ref: 'task_concierge_nlu_data'
    },
    task_concierge_user_selection: {
        name: 'TASK CONCIERGE USER SELECTION',
        ref: 'task_concierge_user_selection'
    },
    task_concierge_successful_creation: {
        name: 'TASK CONCIERGE SUCCESSFUL CREATION',
        ref: 'task_concierge_successful_creation'
    },
    click_partner_card: {
        name: "CLICK PARTNER CARD",
        ref: "click_partner_card"
    },
    upload_timeline_documents: {
        name: 'UPLOAD TIMELINE DOCUMENTS',
        ref: 'upload_timeline_documents'
    },
    submit_capture: {
        name: 'SUBMIT CAPTURE',
        ref: 'submit_capture'
    },
    authorize_expense: {
        name: 'AUTHORIZE EXPENSE',
        ref: 'authorize_expense'
    },
    delete_expense: {
        name: 'DELETE EXPENSE',
        ref: 'delete_expense'
    },
    pay_expense: {
        name: 'PAY EXPENSE',
        ref: 'pay_expense'
    },
    void_expense: {
        name: 'VOID EXPENSE',
        ref: 'void_expense'
    },
    approve_bill: {
        name: 'APPROVE BILL',
        ref: 'approve_bill'
    },
    reject_bill: {
        name: 'REJECT BILL',
        ref: 'reject_bill'
    },
    pay_bill: {
        name: 'PAY BILL',
        ref: 'pay_bill'
    },
    void_bill: {
        name: 'VOID BILL',
        ref: 'void_bill'
    },
    allocate_shares: {
        name: 'ALLOCATE SHARES',
        ref: 'allocate_shares'
    },
    remove_shares: {
        name: 'REMOVE SHARES',
        ref: 'remove_shares'
    },
    transfer_shares: {
        name: 'TRANSFER SHARES',
        ref: 'transfer_shares'
    },
    appoint_director: {
        name: 'APPOINT DIRECTOR',
        ref: 'appoint_director'
    },
    update_director_role: {
        name: 'UPDATE DIRECTOR ROLE',
        ref: 'update_director_role'
    },
    unappoint_director: {
        name: 'UNAPPOINT DIRECTOR',
        ref: 'unappoint_director'
    },
    update_member_identity: {
        name: 'UPDATE MEMBER IDENTITY',
        ref: 'update_member_identity'
    },
    create_member_identity: {
        name: 'CREATE MEMBER IDENTITY',
        ref: 'create_member_identity'
    },
    manual_merge_member_identities: {
        name: 'MANUAL MERGE MEMBER IDENTITIES',
        ref: 'manual_merge_member_identities'
    },
    MEMBERS: {
        ORGANIC_EVENT: 'organic_event',
        LEGACY_EVENT: 'legacy_event',
        IDENTITY_MERGE_PROCESS_EVENT: 'identity_merge_process_event'
    },
    add_new_user_to_entity: {
        name: 'ADD NEW USER TO ENTITY',
        ref: 'add_new_user_to_entity'
    },
    delete_user_from_entity: {
        name: 'DELETE USER FROM ENTITY',
        ref: 'delete_user_from_entity'
    },
    add_new_user_to_service_provider: {
        name: 'ADD NEW USER TO SERVICE PROVIDER',
        ref: 'add_new_user_to_service_provider'
    },
    delete_user_from_service_provider: {
        name: 'DELETE USER FROM SERVICE PROVIDER',
        ref: 'delete_user_from_service_provider'
    },
    view_task_message_content_zavehub: {
        name: 'VIEW TASK MESSAGE CONTENT ZAVEHUB',
        ref: 'view_task_message_content_zavehub'
    },
    view_task_message_content_zave: {
        name: 'VIEW TASK MESSAGE CONTENT ZAVE',
        ref: 'view_task_message_content_zave'
    },
    send_member_identity_kyc: {
        name: 'SEND MEMBER IDENTITY KYC',
        ref: 'send_member_identity_kyc'
    },
    send_member_identity_kyc_during_incorporation: {
        name: 'SEND MEMBER IDENTITY KYC DURING INCORPORATION',
        ref: 'send_member_identity_kyc_during_incorporation'
    },
    create_new_entity: {
        name: 'CREATE NEW ENTITY',
        ref: 'create_new_entity'
    },
    modify_entity_details: {
        name: 'MODIFY ENTITY DETAILS',
        ref: 'modify_entity_details'
    }
};
module.exports = EVENTS;
